import type { FilterSelectOption } from 'models/common/Filters/SelectFieldFilter'
import type { DatePreset } from 'models/common/Filters/DateFilterModel'
import type { SelectOption } from '../../Select/Select'
import { SelectFilterIcon } from 'models/common/Filters/SelectFieldFilter'
import { SvgIcons } from '../../Icon/Icon'

export const datePresetToSelectOption = function (preset: DatePreset) {
  return { text: preset, value: preset }
}

export function filterValueOptionAsSelectOption(option: FilterSelectOption): SelectOption {
  return { text: option.text, value: option.value }
}

export function SvgForSelectFilterIcon(icon: SelectFilterIcon): typeof SvgIcons.UserSvg {
  switch (icon) {
    case SelectFilterIcon.User:
      return SvgIcons.UserFilterSvg
    case SelectFilterIcon.Checklist:
      return SvgIcons.ChecklistFilterSvg
    case SelectFilterIcon.Vehicle:
      return SvgIcons.VehicleFilterSvg
    case SelectFilterIcon.Filter:
      return SvgIcons.FilterFilterSvg
    case SelectFilterIcon.UserRole:
      return SvgIcons.RoleFilterSvg
    case SelectFilterIcon.Status:
      return SvgIcons.StatusFilterSvg
  }
}